import FormEditOrAssignPermissionsBodyUsersItem from './FormEditOrAssignPermissionsBodyUsersItem';
import { Button, Input, Label, ScrollArea, Separator } from '@/components/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useUserConnected } from '@/hooks';
import { useEmployees } from '../../hooks';
import { X } from 'lucide-react';
import { Fragment } from 'react';
import { TFormData } from '.';

const FormEditOrAssignPermissionsBodyUsers = () => {

  const { control, setValue } = useFormContext<TFormData>();
  const filterByUsernameOrEmail = useWatch({ control, name: 'filter.usernameOrEmail' });
  const userId = useWatch({ control, name: '_id' });
  const { userConnected } = useUserConnected();
  const { employees } = useEmployees();
  
  let employeesFiltered = (
    [...employees]
      .filter(l => l._id !== userId)
      .filter(
        l => (
          filterByUsernameOrEmail?.length === 0
            ? true
            : (
              l.username.toLowerCase().includes(filterByUsernameOrEmail.toLowerCase()) ||
              l.email.toLowerCase().includes(filterByUsernameOrEmail.toLowerCase())
            )
        )
      )
  );

  if (!userConnected?.root) {
    employeesFiltered = [...employeesFiltered].filter(l => !l.roles.root);
  }

  const handleOnClickBtnClear = () =>
    setValue('filter.usernameOrEmail', '');

  const handleOnChangeInput = (e: any) => {
    const value = e.target.value;
    setValue('filter.usernameOrEmail', value);
  };

  return (
    <>
      <div className='flex flex-col gap-2 px-3'>
        <Label>
          Rechercher utilisateur
        </Label>
        <div className='relative'>
          <Input
            className='pr-12'
            value={filterByUsernameOrEmail}
            onChange={handleOnChangeInput}
            placeholder={`Par nom d'utilisateur ou email`} />
          {
            filterByUsernameOrEmail &&
            <Button
              className='absolute bottom-1.5 right-1 h-7'
              onClick={handleOnClickBtnClear}
              variant={'ghost'}
              size={'sm'}>
              <X size={16} />
            </Button>
          }
        </div>
      </div>
      <ScrollArea className='flex-1 overflow-auto flex flex-col px-3'>
        {
          employeesFiltered
            .map(
              l => (
                <Fragment key={l._id}>
                  <FormEditOrAssignPermissionsBodyUsersItem employee={l} />
                  <Separator className='my-1 opacity-35' />
                </Fragment>
              )
            )
        }
      </ScrollArea>
    </>
  );

};

export default FormEditOrAssignPermissionsBodyUsers;
